export const title = `AI会记·会员支付`;
export const PAY_ORDER_INFO = "pay_order_info";
export const MAX_PAY_TIME = 10;